var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"portability-loader"},[_c(_setup.HeadingDisplayLoader,{staticClass:"portability-loader__heading",attrs:{"size":"medium"}}),_c(_setup.SkeletonLoader,{staticClass:"portability-loader__rows"},_vm._l((3),function(index){return _c('div',{key:index,staticClass:"portability-loader__row"})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }